import { render, staticRenderFns } from "./ModalDepara.vue?vue&type=template&id=7b6d7262&"
import script from "./ModalDepara.vue?vue&type=script&lang=js&"
export * from "./ModalDepara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports